// 柱状图配置
export const barOptionConfig = function(seriesData) {
	// console.log(seriesData)
	const getSeriesData = () => {
		let series = [];
		if(seriesData){
			for(let i = 0; i<seriesData.data.length; i++){
				if(!seriesData.data[i].markLine){
					series[i] = {
						name:seriesData.data[i].name,
						type:seriesData.type?seriesData.type:'bar',
						barWidth : 15,
						stack: seriesData.type==="line"?"":"搜索引擎",
						data:seriesData.data[i].data
					}
				}else{
					series[i] = seriesData.data[i]
				}

			}
		}
		return series;
	}
	let OptionConfig = {
		dataZoom: seriesData.commondataZoom?[
			{
			  height:20,
			  type: "slider",
			  show: true,
			  xAxisIndex: [0],
			  left: 0,
			  bottom: 30,
			  start: 0,
			  end: 50, //初始化滚动条
			  fillerColor:'#269cdb',
			  showDataShadow:false,
			  zoomLock:true,//滚动条不能缩放
			}
		  ]:[{show:false}],//x轴下方滚动条
		tooltip : {
			
			trigger: 'axis',
			axisPointer : {            // 坐标轴指示器，坐标轴触发有效
				type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			},
			confine:true,
			formatter: function (params) {
				let html=params[0].name+'<br>'
				params.forEach(item=>{
					let name=item.seriesName
					let data=''
					// 文字长度以17个字换行展示
					if(item.seriesName.length> 50){
						let l = Math.ceil(item.seriesName.length/50)
						for(let i = 1;i <= l;i++){
							if(i < l){
								data += name.slice(i*50 - 50,i * 50)+'</br>';
							}else if(i === l){
								data += name.slice((l-1)*50,item.seriesName.length)
							}
						}
					}else{
						data=name
					}
					data=item.marker+name
					html+=`<div style='display:flex; justify-content:space-between'>
					<div  style='margin-right:20px;'>${data}</div><div>${item.value}${seriesData.data.percent?'%':''}</div></div>`
				})
				return html
		   }
		},
		eventName:'mousemove',
		toolbox: seriesData.toolbox ? {
			feature: {
				saveAsImage: {}
			},
			iconStyle:{
				borderColor:"#409eff"
			},
			right:30,
			emphasis:{
				iconStyle:{
					borderColor:"#409eff",
					textBackgroundColor:"#9999",
				}
			},
		}:{},
		legend:seriesData.madeLegend?seriesData.madeLegend: {
			type: 'scroll',
			data:seriesData.legend,
			y: 'bottom',
			x:'center',
			bottom: 30,
			itemWidth: 8,
			itemHeight: 8,
			selected:seriesData.selected
		},
		grid:seriesData.grid?seriesData.grid: {
			left: '3%',
			right: '3%',
			bottom: '20%',
			top:'5%',
			containLabel: true
		},
		xAxis : [
			{
				type: 'category',
				axisTick: seriesData.axisTick?seriesData.axisTick:{ splitNumber: '10%' },
				axisLine: {
					lineStyle: {
						color:'#edecec',
						width: 1
					}
				},
				axisLabel: {
					textStyle: {
						color: '#000'
					}
				},
				data : seriesData.xData
			}
		],
		yAxis: [{
			type: 'value',
			nameTextStyle: {
			  color: '#000'
			},
			axisLine: {
			  lineStyle: {
				color: '#ccc', // 颜色
				width: 1 // 粗细
			  }
			},
			axisLabel: {
			  textStyle: {
				color: '#000'
			  }
			},
			splitLine: { //网格线
			  lineStyle: {
				type: 'dashed' //设置网格线类型 dotted：虚线   solid:实线
			  },
			  show: true
			}
		}],
		color:['#3aa0ff', '#975fe4', '#36cbcb', '#4dcb73', '#fad337', '#8300d7', '#f2637b', '#ff9f7f', '#e7bcf3', '#9fe6b8', '#9d96f5', '#cbb99d', '#31b573', '#a8d59d', '#e1c81d', '#5ca341', '#7a7700','#91b9cd','#3aa0ff', '#975fe4',],
		series:getSeriesData()
	}
	return OptionConfig;
  }
